import { useEffect, useState } from "react";

interface ICookiebotConsent {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
}

interface ICookiebot {
  consent?: ICookiebotConsent;
}

declare global {
  interface Window {
    Cookiebot?: ICookiebot;
  }
}

const cookiebotConsentEvents = ["CookiebotOnConsentReady", "CookiebotOnAccept", "CookiebotOnDecline"] as const;

export const getIsStatisticsConsentGiven = () => window.Cookiebot?.consent?.statistics === true;

// Tracks the Cookiebot "statistics" consent category. Returns false until the
// Cookiebot script has loaded and reported an affirmative consent state.
export const useCookiebotConsent = () => {
  const [isStatisticsConsentGiven, setIsStatisticsConsentGiven] = useState(getIsStatisticsConsentGiven);

  useEffect(() => {
    const updateConsent = () => {
      setIsStatisticsConsentGiven(getIsStatisticsConsentGiven());
    };

    // Sync in case a consent event fired between the initial render and this effect
    updateConsent();

    for (const eventName of cookiebotConsentEvents) {
      window.addEventListener(eventName, updateConsent);
    }

    return () => {
      for (const eventName of cookiebotConsentEvents) {
        window.removeEventListener(eventName, updateConsent);
      }
    };
  }, []);

  return { isStatisticsConsentGiven };
};
